<template>
    <Popup
        buttonText="popupAcceptAnyOdds_gotIt"
        title="popupAcceptAnyOdds_title"
        v-bind:contentStyle="acceptAnyOddsPopupStyle"
        v-on:callback="closeAcceptAnyOddsBanner"
    >
        <template #content>
            <p>{{ i18n.t('popupAcceptAnyOdds_introduction') }}</p>
            <div class="PopupAcceptAnyOdds-toggle">
                {{ i18n.t('acceptAnyOdds') }}
                <SwitchButton
                    name="acceptAnyOdds"
                    v-bind:value="customerInfo.isAcceptAnyOdds"
                    v-on:toggle="toggleAcceptAnyOdds"
                />
            </div>
            <p>{{ i18n.t('popupAcceptAnyOdds_introduction2') }}</p>
        </template>
    </Popup>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { defineComponent } from 'vue';
    import Popup from '@/components/common/Popup.vue';
    import SwitchButton from '@/components/common/SwitchButton.vue';
    import { TextAlign, ZIndex } from '@/interface/enum';
    import Api from '@/libraries/api';
    import { i18n } from '@/libraries/i18n';
    import { useAccountStore } from '@/stores/accountStore';
    import { useRootStore } from '@/stores/rootStore';

    export default defineComponent({
        name: 'PopupAcceptAnyOdds',
        components: {
            SwitchButton,
            Popup,
        },
        setup() {
            const { setShowAcceptAnyOddsBanner, setFailedPlaceBetShowAaoBanner } = useRootStore();
            const { updateCustomerInfo } = useAccountStore();
            const { customerInfo } = storeToRefs(useAccountStore());

            async function toggleAcceptAnyOdds(newVal: boolean) {
                const response = await Api.updateIsAcceptAnyOdds(newVal);
                updateCustomerInfo(response);
            }

            function closeAcceptAnyOddsBanner() {
                setFailedPlaceBetShowAaoBanner(false);
                setShowAcceptAnyOddsBanner(false);
            }

            const acceptAnyOddsPopupStyle = {
                zIndex: ZIndex.AcceptAnyOddsPopup,
                textAlign: TextAlign.Left,
            };

            return {
                toggleAcceptAnyOdds,
                updateCustomerInfo,
                customerInfo,
                i18n,
                closeAcceptAnyOddsBanner,
                acceptAnyOddsPopupStyle,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/popupAcceptAnyOdds";
</style>
